export const assessmentData: any = {
  date: "",//
  service_booking_date: "",//
  lead_expert:"",
  service_booking_time: "",//
  comments: [],
  session_history:[],
  time: "",//
  date_time: "", //
  expert: "",//
  name: "",//
  email: "",//
  phone: "",//
  call_picked: "",
  age: "",//
  gender: "",//
  country: "",
  state: "",//
  city: "",//
  nationality: "",
  languages: [],// !name
  educational_qualification: "",//
  relationship_status: "",//
  dependents: "",//
  student: "",//
  occupation: "",//
  occupation_type: "",//
  family_mental_history: "",//
  symptoms: "",//
  frequency_of_symptoms: "",//
  medication_history: "",//
  therapeutic_histroy: "",//
  types_of_theraputic_history: [],//
  urgency_of_intervention: "",//
  gender_of_therapist: "",//
  age_group_of_therapist: "",//
  therapy_delivery_modes: [],//
  therapy_type: [],//
  preferred_language:"",
  expert_suggested: "",
  suggested_expert_name1: "",//
  suggested_expert_name2: "",//
  suggested_expert_name3: "",//
  suggest_therapy_type: "",//
  notes: "",//
  ehc_followup_notes: "",//
  reason_for_interest: "",//
  length_of_concern: "",//
  current_physical_fitness: "",//
  exercise_routine: "",
  health_problems: "",//
  physical_pain: "",//
  physical_pain_description: "",
  budget: "",//
  issues: [], //"!name"
  lead_owner: "",//
  lead_origin:"",
  lead_status: "",//
  new_lead_status: "",//
  lead_discovery_expert_mapping_datetime: "",
  booking_entry: [],//
  lead_discovery_expert_mapping_template: "",
  lead_expert_mapping_datetime: "",
  lead_expert_mapping_template: "",
  message_history:[],
  payment_link_history:[],
};


export const updateAssessmentData = (data: any) =>  {
 return {
  date: data.date,
  service_booking_date: data.service_booking_date,
  lead_expert:data.lead_expert,
  service_booking_time: data.service_booking_time,
  comments: data.comments,
  time: data.time,
  date_time: data.date_time,
  expert: data.expert,
  session_history:data.session_history || [],
  name:  data.client_information.name,
  email: data.client_information.email,
  phone: data.client_information.phone,
  call_picked: data.call_picked,
  age: data.client_information.age,
  gender: data.client_information.gender,
  country: data.client_information.country,
  state: data.client_information.state,
  city: data.client_information.city,
  nationality:  data.client_information.nationality,
  languages:  data.client_information.languages_known  ,
  educational_qualification: data.client_information.educational_qualification,
  relationship_status: data.client_information.relationship_status,
  dependents: data.client_information.dependents,
  student: data.client_information.student,
  occupation: data.client_information.occupation,
  occupation_type: data.client_information.occupation_type,
  family_mental_history: data.client_information.family_mental_history,
  symptoms: data.screening_information.symptoms,
  frequency_of_symptoms: data.screening_information.frequency_of_symptoms,
  issues: data.screening_information.issues, 
  medication_history: data.screening_information.medication_history,
  therapeutic_histroy: data.screening_information.therapeutic_histroy,
  types_of_theraputic_history: data.screening_information.types_of_theraputic_history,
  urgency_of_intervention: data.screening_information.urgency_of_intervention,
  gender_of_therapist: data.expert_preferences.gender_of_therapist,
  age_group_of_therapist: data.expert_preferences.age_group_of_therapist,
  therapy_delivery_modes: data.treatment_preferences.therapy_delivery_modes,
  therapy_type: data.treatment_preferences.therapy_type,
  preferred_language:data.treatment_preferences.preferred_language ,
  expert_suggested: data.screening_result.expert_suggested,
  suggested_expert_name1: data.screening_result.suggested_expert_name1,
  suggested_expert_name2: data.screening_result.suggested_expert_name2,
  suggested_expert_name3: data.screening_result.suggested_expert_name3,
  suggest_therapy_type: data.screening_result.suggest_therapy_type,
  notes: data.notes,
  ehc_followup_notes: data.ehc_followup_notes,
  reason_for_interest: data.screening_result.reason_for_interest,
  length_of_concern: data.screening_result.length_of_concern,
  current_physical_fitness: data.screening_result.current_physical_fitness,
  exercise_routine: data.screening_result.exercise_routine,
  health_problems: data.screening_result.health_problems,
  physical_pain: data.screening_result.physical_pain,
  physical_pain_description: data.screening_result.physical_pain_description,
  budget: data.screening_result.budget,
  lead_owner: data.lead_owner,
  lead_origin:data.lead_origin,
  lead_status: data.lead_status,
  new_lead_status: data.new_lead_status,
  lead_discovery_expert_mapping_datetime: data.lead_discovery_expert_mapping_datetime,
  booking_entry: data.booking_entry,
  lead_discovery_expert_mapping_template: data.lead_discovery_expert_mapping_template,
  lead_expert_mapping_datetime: data.lead_expert_mapping_datetime,
  lead_expert_mapping_template: data.lead_expert_mapping_template,
  message_history:data.message_history,
  payment_link_history:data.payment_link_history || [],
 }
}